import {ACCOUNT_USER_LIST,ACCOUNT_USER_MESSAGE,SHOW_LOADING,NOTIFICATION_LIST, INVITE_ACCOUNT_USER_LIST, HIDE_LOADING, ALL_USER_LIST, GET_ACCOUNT_USER_LIST, GET_INVITE_ACCOUNT_USER_LIST, DELETE_NOTIFICATION, DELETE_NOTIFICATIONS} from "redux/constants/user";

const initState = {
    loading : true,
    notificationLoading: false,
    accountUserList : [],
    allUserList:[],
    inviteAccountUserList:[],
    notificationDataList:[],
    listType: null,
    listLoaded: false,
    message: '',
    showMessage: false,
    redirect : "",
    allowRedirect:false,
    status:null,
    token:null,
    userVisible:false
}

const user = (state=initState,action)=>{
    switch(action?.type){
        case GET_ACCOUNT_USER_LIST: {
            const nextType = action?.requestData?.type;
            const shouldResetList = nextType && nextType !== state.listType;
            return {
                ...state,
                loading: true,
                listLoaded: false,
                showMessage: false,
                listType: nextType || state.listType,
                accountUserList: shouldResetList ? [] : state.accountUserList
            }
        }
        case GET_INVITE_ACCOUNT_USER_LIST: {
            const nextType = action?.requestData?.type;
            const shouldResetList = nextType && nextType !== state.listType;
            return {
                ...state,
                loading: true,
                listLoaded: false,
                showMessage: false,
                listType: nextType || state.listType,
                inviteAccountUserList: shouldResetList ? [] : state.inviteAccountUserList
            }
        }
        case ACCOUNT_USER_LIST: 
        return {
            ...state,
            accountUserList : action.accountUserList,
            allowRedirect :false,
            showMessage:false,
            loading : false,
            listLoaded: true
        }
        case ALL_USER_LIST: 
        return {
            ...state,
            allUserList : action.allUserList,
            allowRedirect :false,
            showMessage:false,
            userVisible:false,
            loading : false
        }
        case INVITE_ACCOUNT_USER_LIST: 
        return {
            ...state,
            inviteAccountUserList : action.inviteAccountUserList,
            allowRedirect :false,
            showMessage:false,
            loading : false,
            listLoaded: true,
            listType: "pendingUsers"
        }
        case ACCOUNT_USER_MESSAGE:
            return {
                ...state,
                message : messageRead(action),
                status : action?.response?.status,
                showMessage:true,
                allowRedirect: false,
                loading : false,
                notificationLoading: false,
                listLoaded: true
            }
        case SHOW_LOADING: {
            return {
                ...state,
                loading: true
            }
        }    
        case HIDE_LOADING: {
            return {
                ...state,
                loading: false
            }
        }
        case DELETE_NOTIFICATION:
        case DELETE_NOTIFICATIONS: {
            return {
                ...state,
                notificationLoading: true,
            }
        }
        case NOTIFICATION_LIST:{
            return{
                ...state,
                notificationDataList : action.notificationDataList,
                allowRedirect: false,
                loading : false,
                notificationLoading: false,
            }
        }
        default:
            return state
    }
}

const messageRead=(action)=>{
    if(action?.response?.status===401 || action?.response?.response?.status){
        return "Unauthorized"
    }
	if(action?.response && action?.response?.response && action?.response?.response?.data && action?.response?.response?.message){
	 return action?.response?.response?.data?.message;
	}else if(action?.response && action?.response?.data && action?.response?.data?.message){
		return action?.response?.data?.message;
	}else if(action?.response && action?.response?.data && action?.response?.data?.message){
		return action?.response?.data?.message;
	}else if(action?.response && action?.response?.data){
		return action?.response?.data;
	}else if(action?.data?.message){
		return action?.data?.message;
	}else if(action?.data){
		return action?.data;
	}else{
		return "something went wrong"
	}
}

export default user;